import React from 'react';
import { questions } from '../data/landing';
export function QuestionsSection() {
  return <section className="border-t border-line bg-night" data-id="element-150" data-mp="2aqrdamtom3pd">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-6 md:py-16 lg:py-20" data-id="element-151" data-mp="2ap6hktvmsepx">
        <h2 className="max-w-3xl font-display text-xl leading-tight text-cream md:text-3xl lg:text-4xl" data-id="element-152" data-mp="25qlf0nswpiyb">
          ¿Alguna vez has sentido que hay preguntas que merecen una exploración
          más profunda?
        </h2>

        <div className="mt-5 grid gap-6 md:mt-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-153" data-mp="1wtkwuywfkh3b">
          <div className="space-y-3 text-sm leading-relaxed text-muted md:text-base" data-id="element-154" data-mp="1rzgoqcbfi30n">
            <p data-id="element-155" data-mp="1n2829zj8zctl">
              Vivimos rodeados de información. Sin embargo, conocer muchas ideas
              no siempre significa comprender cómo se relacionan entre sí.
            </p>
            <p data-id="element-156" data-mp="1dzp3prmhvmd5">
              <span className="font-display text-cream" data-id="element-157" data-mp="1e0785bjb96w5">EL LIBRO DEL DESPERTAR</span>{' '}
              te invita a explorar estas preguntas desde una perspectiva que
              conecta filosofía, simbolismo y tradiciones espirituales.
            </p>
            <p className="pt-1 font-serif text-lg leading-snug text-cream md:text-2xl" data-id="element-158" data-mp="vhjvn2pkuv2l">
              No se trata de aceptar todo sin cuestionarlo.
            </p>
            <p data-id="element-159" data-mp="hnshti4tcp12">
              Se trata de observar, reflexionar y desarrollar una mirada más
              amplia sobre aquello que creías conocer.
            </p>
            <p className="text-gold-light" data-id="element-160" data-mp="19i2y7ub9x8xd">
              Si disfrutas explorando las preguntas profundas de la existencia,
              este libro es para ti.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-161" data-mp="10fbk1mr0jz21">
            {questions.map(q => <li key={q} className="py-3.5 font-serif text-lg italic leading-snug text-cream md:py-5 md:text-2xl" data-id="element-162" data-mp="15dvb21kgs119">
                {q}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}